var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "green_status",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#8DFD3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStatus);
export default __webpack_public_path__ + "static/media/green-status.6336ab7c3743b780ed0a60e86f8b55c0.svg";
export { ForwardRef as ReactComponent };